// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".a-text-layer[data-v-22c68eaa]{font-size:24px}", "",{"version":3,"sources":["webpack://./resources/js/frontend/components/modules/psd-layers/layer-views/TextLayer.vue"],"names":[],"mappings":"AACA,+BACE,cAAF","sourcesContent":["\n.a-text-layer {\n  font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
